import flatten from 'lodash/flatten';
import filter from 'lodash/filter';

import {
    ORGANIZER_POPULAR_CATEGORIES,
} from 'consumer-utils/constants/categories';

export const getSortedOrganizersByPopularCategories = (organizers) => (
    flatten(ORGANIZER_POPULAR_CATEGORIES.map(
        (category) => filter(organizers, ({categoryId}) => category === categoryId)
    ))
);
